export default "__VITE_ASSET__7fab13d0__"